export default "__VITE_ASSET__9431e97b__"